import { Controller } from "@hotwired/stimulus"

// Recorta la descripción de la ficha de producto a N líneas (CSS .is-clamped) y muestra
// "Leer más" solo cuando de verdad sobra texto. Se remide cuando llega la fuente web.
// Uso: data-controller="clamp" con targets body y toggle (ver products/show).
export default class extends Controller {
  static targets = ["body", "toggle"]
  static values = {
    moreText: { type: String, default: "Leer más" },
    lessText: { type: String, default: "Leer menos" }
  }

  connect() {
    this.expanded = false
    this.measure()
    document.fonts?.ready?.then(() => this.measure())
  }

  toggle() {
    this.expanded = !this.expanded
    this.bodyTarget.classList.toggle("is-clamped", !this.expanded)
    this.toggleTarget.textContent = this.expanded ? this.lessTextValue : this.moreTextValue
    this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))
  }

  // Aplica el recorte y decide si el botón hace falta (solo mientras está plegado)
  measure() {
    if (this.expanded) return
    this.bodyTarget.classList.add("is-clamped")
    const overflows = this.bodyTarget.scrollHeight > this.bodyTarget.clientHeight + 1
    this.toggleTarget.hidden = !overflows
    if (!overflows) this.bodyTarget.classList.remove("is-clamped")
  }
}
